<div *ngIf="!indexPerfRiskInfo()" class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50">
  <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
</div>
<div class="flex justify-center">
  <div *ngIf="indexPerfRiskInfo() as performanceRiskInfo" class="py-6 space-y-6 w-[80vw]">
    <h2 class="text-lg font-bold text-gray-800 border-l-4 border-green-600  pl-2 mb-2 ">Performance and risk analysis
    </h2>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6" *ngIf="indexHeaderInfo() as hi">
      <div class="border border-gray-200  overflow-x-auto">
        <p class="bg-bnpp-green text-white font-medium px-4 py-2 text-sm">PERFORMANCE ANALYSIS</p>
        <table class="min-w-full text-xs text-center">
          <thead class="bg-gray-100 ">
            <tr class="py-5">
              <th class="text-left w-[30%] py-5 px-2 font-medium">Sliding</th>
              <th class="text-left w-[14%] font-medium">1M</th>
              <th class="text-left w-[14%] font-medium">3M</th>
              <th class="text-left w-[14%] font-medium">6M</th>
              <th class="text-left w-[14%] font-medium">1Y</th>
              <th class="text-left w-[14%] font-medium">3Y*</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pr of performanceRiskInfo" class="border-t">
              <td class="text-left w-[30%] py-3 px-2"><span [title]="pr?.PerformanceData?.MarketingName"
                  class="text-overflow-ellipsis marketing-label">{{pr?.PerformanceData?.MarketingName}}</span></td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Perf1M ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Perf1M)}}
                %
              </td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Perf3M ?? 0))">
                {{
                getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Perf3M)}}
                %
              </td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Perf6M ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Perf6M)}}
                %
              </td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Perf1Y ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Perf1Y)}}
                %
              </td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Perf3Y ?? 0))">
                {{pr.PerformanceData.Performance?.[0]?.Perf3Y !== undefined ?
                getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Perf3Y) + '%' : ''}}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="min-w-full text-xs  text-center">
          <thead class="bg-gray-100  font-semibold">
            <tr>
              <th class="text-left w-[25%] py-5 px-2 font-medium">Annual</th>
              <th class="w-[5%]">
                <div class="flex items-center  justify-center">
                  <button class=" p-1 " (click)="scrollAnnual(-1)">
                    < </button>
                </div>
              </th>
              <th class="text-left w-[14%] font-medium">YTD</th>
              <ng-container *ngFor="let year of visibleYears(performanceRiskInfo[0]); let last=last">
                <th [ngClass]="{'w-[14%]': !last, 'w-[5%]': last}" class="text-left font-medium">{{year.Year}}</th>
              </ng-container>
              <th class="w-[9%] text-left">
                <button class="p-1  " (click)="scrollAnnual(1)">
                  >
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-t" *ngFor="let pr of performanceRiskInfo">
              <td class="text-left py-3 px-2 w-[25%]"><span [title]="pr?.PerformanceData?.MarketingName"
                  class="text-overflow-ellipsis marketing-label">{{pr?.PerformanceData?.MarketingName }}</span></td>
              <td class="w-[5%]"></td>
              <td class="text-left w-[14%]"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.PerfYTD ?? 0))"> {{
                getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.PerfYTD) }}%
              </td>
              <ng-container *ngFor="let year of visibleYears(pr); let last=last">
                <td *ngIf="year.Value !== null && year.Value !== undefined" class="text-left"
                  [ngClass]="getReturnClass(year.Value*100, last)">{{getSignedFormattedValue(year.Value)}}%
                </td>
              </ng-container>
              <td class="w-[5%]"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="border border-gray-200  overflow-x-auto">
        <p class="bg-bnpp-green text-white font-medium px-4 py-2 text-sm">RISK ANALYSIS</p>
        <table class="min-w-full text-xs text-center">
          <thead class="bg-gray-100 ">
            <tr>
              <th class="text-left p-2 py-5 font-medium">3Y</th>
              <th class="text-left p-2 font-medium">Beta</th>
              <th class="text-left p-2 font-medium">Annualized<br>volatility*</th>
              <th class="text-left p-2 font-medium">Sharpe<br>ratio*</th>
              <th class="text-left p-2 font-medium">Max<br>drawdown</th>
              <th class="text-left p-2 font-medium">Time to<br>recovery</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pr of performanceRiskInfo" class="border-t">
              <td class="text-left p-2 py-3"><span [title]="pr?.PerformanceData?.MarketingName"
                  class="text-overflow-ellipsis marketing-label">{{pr?.PerformanceData?.MarketingName}}</span></td>
              <td class="text-left p-2" [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Beta3Y ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Beta3Y)}}

              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.Volatility3Y ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.Volatility3Y)}}
                %
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.SharpeRatio3Y ?? 0))">
                {{getSignedValue(pr.PerformanceData.Performance?.[0]?.SharpeRatio3Y)}}
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.MaxDrawdown3Y ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.MaxDrawdown3Y )}}
                %
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.TimeToRecovery3Y ?? 0))">
                {{(pr.PerformanceData.Performance?.[0]?.TimeToRecovery3Y ?? 0)}}
                W
              </td>
            </tr>
          </tbody>
        </table>
        <table class="min-w-full text-xs text-center">
          <thead class="bg-gray-100 font-semibold">
            <tr>
              <th class="text-left p-2 py-5 font-medium">Since Inception</th>
              <th class="text-left p-2 font-medium">Beta<br>Life</th>
              <th class="text-left p-2 font-medium">Annualized<br>volatility*</th>
              <th class="text-left p-2 font-medium">Sharpe<br>ratio*</th>
              <th class="text-left p-2 font-medium">Max<br>drawdown</th>
              <th class="text-left p-2 font-medium">Time to<br>recovery</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pr of performanceRiskInfo" class="border-t">
              <td class="text-left p-2 py-3"><span [title]="pr?.PerformanceData?.MarketingName"
                  class="text-overflow-ellipsis marketing-label">{{pr?.PerformanceData?.MarketingName}}</span></td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.BetaLife ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.BetaLife)}}

              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.VolatilityLife ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.VolatilityLife)}}
                %
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.SharpeRatioLife ?? 0))">
                {{getSignedValue(pr.PerformanceData.Performance?.[0]?.SharpeRatioLife)}}
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.MaxDrawdownLife ?? 0))">
                {{getSignedFormattedValue(pr.PerformanceData.Performance?.[0]?.MaxDrawdownLife)}}
                %
              </td>
              <td class="text-left p-2"
                [ngClass]="getReturnClass((pr.PerformanceData.Performance?.[0]?.TimeToRecoveryLife ?? 0))">
                {{(pr.PerformanceData.Performance?.[0]?.TimeToRecoveryLife ?? 0)}}
                W
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="text-xs italic mt-2">*Annualized</p>
  </div>
</div>
